// Business contact details — swap these placeholders with the real info.
export const SITE = {
  name: "Take The Leap Junk Removal",
  shortName: "Take The Leap",
  tagline: "We take the junk. You start fresh.",
  phoneDisplay: "(717) 489-8955",
  phoneTel: "+17174898955",
  email: "Leapoffaith626@gmail.com",
  area: "Hanover, PA + York, Lancaster, Adams & Carroll Counties",
  hours: "Mon–Fri 8am–6pm · Sat 8am–2pm",
  googleReviewUrl: "https://g.page/r/CSCqe4nMoc2TEAI/review",
  facebookUrl: "https://www.facebook.com/share/1DmGU31Pak/?mibextid=wwXIfr",
};

export const IMAGES = {
  cleanRoom:
    "https://images.unsplash.com/photo-1625585598750-3535fe40efb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMGVtcHR5JTIwcm9vbSUyMG1pbmltYWx8ZW58MHx8fHwxNzg4MTkzMzA3fDA&ixlib=rb-4.1.0&q=85",
  junkPile:
    "https://images.unsplash.com/photo-1612965110667-4175024b0dcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxqdW5rJTIwcGlsZXxlbnwwfHx8fDE3ODgxOTMzMTR8MA&ixlib=rb-4.1.0&q=85",
  teamTruck:
    "https://images.unsplash.com/photo-1772544376426-6a42f1dfa74a?fm=jpg&q=85&w=1600&auto=format&fit=crop",
  worker:
    "https://images.unsplash.com/photo-1626984232613-f20f15589bee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx3b3JrZXIlMjBjYXJyeWluZyUyMGJveHxlbnwwfHx8fDE3ODgxOTMzMDd8MA&ixlib=rb-4.1.0&q=85",
  dumpTruck: "/images/haul-step.jpg",
};
